import styles from "./styles.module.css";

const Button = ({
  children,
  onClick,
  variant = "primary",
  size = "medium",
  disabled = false,
  isLoading = false,
  type = "button",
  className = "",
  ...props
}) => {
  const variantClass = styles[variant] || styles.primary;
  const sizeClass = styles[size] || styles.medium;
  const disabledClass = disabled ? styles.disabled : "";
  const loadingClass = isLoading ? styles.loading : "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`${styles.button} ${variantClass} ${sizeClass} ${disabledClass} ${loadingClass} ${className}`}
      {...props}
    >
      {isLoading && (
        <span className={styles.spinnerOverlay}>
          <span className={styles.spinner} />
        </span>
      )}
      <span className={isLoading ? styles.contentHidden : ""}>{children}</span>
    </button>
  );
};

export default Button;
